import { useState } from "react";
import { Heading, Input, Button, Box, VStack, HStack } from "@chakra-ui/react";
import { useToast } from "@chakra-ui/react";

import { WAIT_CONFIRMS } from "../utils/consts";

export default function ClaimItem({ contract, onClaimed, setPageIsLoading }) {
    const toast = useToast();
    const [name, setName] = useState("");
    const [loading, setLoading] = useState(false);

    function showToast(mode, name, description) {
        if (mode === "wait") {
            console.log(`Transaction: Claim ${name}`, description);
            toast({
                title: `Transaction: Claim ${name}`,
                description,
                status: "info",
                duration: 10000,
                isClosable: true,
            });
        } else if (mode === "success") {
            console.log(`Success: Claim ${name}`, description);
            toast({
                title: `Success: Claim ${name}`,
                description,
                status: "success",
                duration: 10000,
                isClosable: true,
            });
        } else if (mode === "error") {
            console.log(`Error: Claim ${name}`, description);
            toast({
                title: `Error: Claim ${name}`,
                description,
                status: "error",
                duration: 10000,
                isClosable: true,
            });
        }
    }

    async function claim() {
        setPageIsLoading(true);
        setLoading(true);
        try {
            const tx = await contract.claim(name);
            showToast("wait", name, tx.hash);
            const receipt = await tx.wait(WAIT_CONFIRMS);
            showToast("success", name, receipt.transactionHash);
            onClaimed();
        } catch (error) {
            showToast("error", name, error.message);
        } finally {
            setName("");
            setLoading(false);
            setPageIsLoading(false);
        }
    }

    return (
        <VStack spacing="2">
            <Box m="3" fontSize="5xl">
                🥚
            </Box>
            <Heading size="sm">新しいNFTを飼う</Heading>
            <HStack>
                <Input
                    w={"13rem"}
                    placeholder="名前をつけてください"
                    value={name}
                    onChange={(evt) => setName(evt.target.value)}
                />
                <Button
                    colorScheme="green"
                    onClick={claim}
                    disabled={!name || loading}
                    isLoading={loading}
                    loadingText="Claiming"
                >
                    Claim
                </Button>
            </HStack>
        </VStack>
    );
}
